import { useState } from 'react';

import calendar from '~/assets/icons/calendar.svg';
import { playSound, Sound } from '~/assets/sounds';
import { numWord } from '~/shared';

import {
	StyledContainer,
	StyledIcon,
	StyledInput,
	StyledRightContainer,
	StyledTextLabel,
} from './DaysInput.styled';

interface IDaysInputProps extends React.HTMLAttributes<HTMLDivElement> {
	value: number;
	changeHandler: any;
	payDays: number;
	maxDays: number;
}

const DaysInput: React.FC<IDaysInputProps> = ({
	value,
	changeHandler,
	payDays,
	maxDays,
}: IDaysInputProps) => {
	const [focus, setFocus] = useState<boolean>(false);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length === 0) {
			if (changeHandler) {
				changeHandler(1);
			}
			return;
		}

		if (parseInt(inputValue) > maxDays - payDays) {
			changeHandler(maxDays - payDays);
			return;
		}

		changeHandler(parseInt(inputValue));
	};

	return (
		<StyledContainer onMouseEnter={() => playSound(Sound.LinkCursor)}>
			<StyledInput
				onChange={onChange}
				value={
					focus ? value : `${value} ${numWord(value, ['день', 'дня', 'дней'])}`
				}
				onFocus={() => setFocus(true)}
				onBlur={() => setFocus(false)}
				placeholder={'Введите кол-во дней'}
				tabIndex={-1}
			/>
			<StyledRightContainer>
				<StyledTextLabel>
					<span>{payDays}</span>
					<span>&nbsp;/ {maxDays}</span>
				</StyledTextLabel>
				<StyledIcon src={calendar} />
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { DaysInput };
